export default pis => {

    var ftap="3298765432";
    var total=0;
    var resto=0;
    var numPIS=0;
    var strResto="";

	numPIS=pis;

	if (numPIS=="" || numPIS==null)
	{
		return false;
	}

	for(var i=0;i<=9;i++)
	{
		var resultado = (numPIS.slice(i,i+1))*(ftap.slice(i,i+1));
		total=total+resultado;
	}

	resto = (total % 11)

	if (resto != 0)
	{
		resto=11-resto;
	}

	if (resto==10 || resto==11)
	{
		strResto=resto+"";
		resto = strResto.slice(1,2);
	}

	if (resto!=(numPIS.slice(10,11)))
	{
		return false;
	}

	return true;
}